const state = {
  navigation: {
    search: undefined,
    orderField: undefined,
    orderMode: undefined,
    customFilter: undefined,
    extraParams: undefined,
  },
  pagination: {
    page: 1,
    per_page: 15,
    total_pages: 1,
  },
  siteSettings: {
    defaultControlPointsView: 'board',
    defaultDashboardView: 'control_points',
  },
};

export default state;
